import { Box } from '@mui/material';
import moment from 'moment';
import {
  DateTimeInput,
  FormDataConsumer,
  Labeled,
  ReferenceArrayInput,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  TextInput,
  minValue,
  required,
} from 'react-admin';
import { Permission } from '../../../components';
import { PERMISSIONS } from '../../../constants';

export const BasicInfoStep = ({ isEdit = false, chainId: propChainId }) => {
  return (
    <>
      <Permission permission={PERMISSIONS.ADMIN}>
        <ReferenceInput sort={{ field: 'name', order: 'ASC' }} source="chainId" reference="chains" perPage={false}>
          <SelectInput
            optionText="name"
            label="Rede"
            emptyText="Nenhum"
            fullWidth
            validate={[required()]}
            inputProps={{ readOnly: isEdit }}
            sx={isEdit ? { pointerEvents: 'none', opacity: 0.6 } : {}}
          />
        </ReferenceInput>
      </Permission>

      <TextInput
        label="Nome"
        source="name"
        fullWidth
        validate={[required()]}
      />

      <Labeled label="Validade do contrato" fullWidth>
        <FormDataConsumer>
          {({ formData }) => (
            <Box sx={{ paddingTop: 2, display: 'flex', gap: 2, width: '100%' }}>
              <DateTimeInput
                source='startDate'
                label='Início'
                locales="pt-BR"
                parse={(value) => moment(value).toISOString()}
                defaultValue={moment().startOf('day').toISOString()}
                sx={{ flex: 1 }}
                required
              />
              <DateTimeInput
                source='endDate'
                label='Término'
                locales="pt-BR"
                parse={(value) => moment(value).toISOString()}
                defaultValue={moment().add(30, 'days').endOf('day').toISOString()}
                validate={[minValue(formData.startDate, 'Data inferior à de início')]}
                sx={{ flex: 1 }}
                required
              />
            </Box>
          )}
        </FormDataConsumer>
      </Labeled>

      <ReferenceInput
        sort={{ field: 'name', order: 'ASC' }}
        source="companyId"
        reference="companies"
        perPage={false}
      >
        <SelectInput
          optionText="name"
          label="Grupo de Transportadora"
          emptyText="Nenhum"
          fullWidth
          validate={[required()]}
          inputProps={{ readOnly: isEdit }}
          sx={isEdit ? { pointerEvents: 'none', opacity: 0.6 } : {}}
        />
      </ReferenceInput>

      <FormDataConsumer>
        {({ formData }) => (
          <ReferenceArrayInput
            sort={{ field: 'name', order: 'ASC' }}
            source="stationIds"
            reference="stations"
            perPage={false}
            filter={{ chainId: formData.chainId || propChainId }}
          >
            <SelectArrayInput
              optionText="name"
              label="Postos"
              emptyText="Nenhum"
              fullWidth
              sx={{ marginBottom: 0.8, paddingTop: 1 }}
              validate={[required()]}
            />
          </ReferenceArrayInput>
        )}
      </FormDataConsumer>
    </>
  );
};
